/* eslint-disable no-else-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, Stepper, Step, StepLabel } from '@material-ui/core';
import styled from 'styled-components';
import moment from 'moment';
import { destroy, formValueSelector } from 'redux-form';
import { addUser } from '../../../actions';
import { USER_STATUSES, ONBOARDING_STEPS, DATE_FORMAT } from '../../../constants';
import { userStateSelector } from '../../../selectors';
import {
  FirstStep,
  SecondBuyerStep,
  SecondSellerStep,
  ThirdSellerStep,
  ThirdBuyerStep,
  FourthBuyerStep,
  FifthBuyerStep
} from './containers/index';
import OfficePhoneNumberBanner from "./components/OfficePhoneNumberBanner";
import TermsAndConditionsModal from "./components/TermsAndConditionsModal";

const StyledPaper = styled(Paper)`
  && {
    max-width: 680px;
    width: 100%;
    margin: 0 auto;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    border-radius: 0;
  }
`;

const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const StyledStepper = styled(Stepper)`
  && {
    justify-content: center;
    max-width: ${props => (props.role === 'buyer' ? '100%' : '860px')};
    margin: 0 auto;
    @media (max-width: 760px) {
      display: none;
    }
  }
`;

const StyledStepperWrapper = styled.div`
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  position: relative;
  margin: 0 auto;
  background: white;
`;

const lastStepToCurrentStep = {
  [ONBOARDING_STEPS.SECOND_SELLER_STEP]: 1,
  [ONBOARDING_STEPS.THIRD_SELLER_STEP]: 2,
  [ONBOARDING_STEPS.SECOND_BUYER_STEP]: 1,
  [ONBOARDING_STEPS.THIRD_BUYER_STEP]: 2,
  [ONBOARDING_STEPS.FOURTH_BUYER_STEP]: 3,
  [ONBOARDING_STEPS.FIFTH_BUYER_STEP]: 4
};

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0
    };
  }

  componentWillMount() {
    const { user, location } = this.props;
    const { step } = location.state || {};
    if (step) {
      this.setState({
        currentStep: lastStepToCurrentStep[step] || 0
      });
    } else if (user && user.status === USER_STATUSES.NEED_TO_COMPLETE_SIGN_UP) {
      this.setState({
        currentStep: lastStepToCurrentStep[user.last_step] || 0
      });
    }
  }

  componentWillUnmount() {
    const { resetForm } = this.props;
    resetForm();
  }

  renderStep = () => {
    const { role } = this.props;
    if (role === 'buyer') {
      return this.buyerSteps();
    } else if (role === 'seller') {
      return this.sellerSteps();
    }
    return <FirstStep nextStep={() => this.setStep(0)} role={role} />;
  };

  sellerSteps = () => {
    const { currentStep } = this.state;
    const { role } = this.props;
    switch (currentStep) {
      case 0:
        return <FirstStep nextStep={() => this.setStep(1)} role={role} />;
      case 1:
        return (
          <SecondSellerStep
            nextStep={() => this.setStep(2)}
          />
        );
      case 2:
        return (
          <ThirdSellerStep
            prevStep={() => this.setStep(1)}
            onSubmit={this.finishOnboarding}
          />
        );
      default:
        return null;
    }
  };

  buyerSteps = () => {
    const { currentStep } = this.state;
    const { role } = this.props;
    switch (currentStep) {
      case 0:
        return <FirstStep nextStep={() => this.setStep(1)} role={role} />;
      case 1:
        return (
          <SecondBuyerStep
            nextStep={() => this.setStep(2)}
          />
        );
      case 2:
        return (
          <ThirdBuyerStep
            nextStep={() => this.setStep(3)}
            prevStep={() => this.setStep(1)}
          />
        );
      case 3:
        return (
          <FourthBuyerStep
            nextStep={() => this.setStep(4)}
            prevStep={() => this.setStep(2)}
          />
        );
      case 4:
        return (
          <FifthBuyerStep
            prevStep={() => this.setStep(3)}
            onSubmit={this.finishOnboarding}
          />
        );
      default:
        return null;
    }
  };

  finishOnboarding = values => {
    const { addUser: dispatchUserAction } = this.props;
    if (values.dealer_license_expiry_date) {
      // eslint-disable-next-line
      values = {
        ...values,
        dealer_license_expiry_date: moment
          .utc(values.dealer_license_expiry_date, DATE_FORMAT)
          .format()
      };
    }
    if (values.credit_card_number) {
      // eslint-disable-next-line
      values = {
        ...values,
        credit_card_number: (values.credit_card_number || '').replace(/\s/g, '')
      };
    }
    if (values.credit_card_expiry_date) {
      // eslint-disable-next-line
      values = {
        ...values,
        credit_card_expiry_date: values.credit_card_expiry_date
          ? moment
              .utc(values.credit_card_expiry_date || '', 'MM/YY')
              .format('YYYY-MM')
          : ''
      };
    }
    const fieldsToFormat = [
      'phone_number',
      'secondary_contact_phone',
      'store_number'
    ];
    fieldsToFormat.forEach(field => {
      if (values[field]) {
        // eslint-disable-next-line
        values = {
          ...values,
          [field]: (values[field] || '').replace(/[\D]/g, '')
        };
      }
    });
    dispatchUserAction({
      ...values,
      // Replace unused spaces from redux-form normalizer
      purchase_option: this.getSelectedMultipleCheckboxes(
        values.purchase_option
      ),
      purchase_method: this.getSelectedMultipleCheckboxes(
        values.purchase_method
      ),
      finished: true
    });
  };

  getSelectedMultipleCheckboxes = (checkboxes = {}) =>
    Object.keys(checkboxes).reduce((acc, key) => {
      if (checkboxes[key]) {
        return [...acc, key];
      }
      return acc;
    }, []);

  setStep = currentStep => {
    this.setState({ currentStep });
    window.scrollTo(0, 0);
  };

  getSteps = () => {
    const { role } = this.props;
    if (!role) {
      return ['User Info'];
    } else if (role === 'buyer') {
      return [
        'User Info',
        'Buyer Info',
        'Credit Card Info',
        'Documents',
        'Purchase Method'
      ];
    }
    return ['User Info', 'Seller Info', 'Purchase Option'];
  };

  render() {
    const { currentStep } = this.state;
    const { role } = this.props;
    return (
      <>
        <StyledStepperWrapper>
          <StyledStepper activeStep={currentStep} role={role}>
            {this.getSteps().map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </StyledStepper>
        </StyledStepperWrapper>
        <StyledPaper>
          <StyledFormWrapper>{this.renderStep()}</StyledFormWrapper>
        </StyledPaper>
        <OfficePhoneNumberBanner />
        <TermsAndConditionsModal />
      </>
    );
  }
}

const selector = formValueSelector('registrationForm');

const mapStateToProps = state => ({
  role: selector(state, 'role'),
  user: userStateSelector(state)
});

const mapDispatchToProps = dispatch => ({
  addUser: body => dispatch(addUser(body).request),
  resetForm: () => dispatch(destroy('registrationForm'))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationForm);
